export default __webpack_public_path__ + "static/media/contact-lawyers.4ef02e7f.mp4";